var NewUserRewardPanel = require("clover/panel/NewUserRewardPanel")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var Panel = xClass("VipPrivilegesPanel", NewUserRewardPanel, function () {
    return cc.CSLoader.createNode("cocos/vip_privileges_panel.csb")
})

var resList = [
    "cocos/vip_privileges_panel.csb",
    "cocos/vip_privileges_racoon_light.csb",
    "cocos/vip_privileges_btn_recharge.csb",
    "cocos/vip_privileges_btn_update.csb",
    "cocos/vip_privileges_bottom_offbottom_light_x.csb",
    "cocos/vip_privileges_bottom_btn_question.csb",
    "cocos/vip_privileges.plist",
    "font/zzgftongxin_40_redstroke.fnt",
    "font/zzgftongxin_40_greenstroke.fnt"
]

Panel.asyncCreate = function (data, onCloseCallback, fail, cancel) {
    function onSuccess() {
        cc.log("vip panel async create data: " + data)
        let panel = Panel.create(data, onCloseCallback)
        panel.popup()
    }
    preloadWithLoading(resList, onSuccess, fail, cancel)
}
Panel.prototype.ctor = function (data, onCloseCallback) {
    var self = this
    self.onCloseCallback = onCloseCallback
    cc.log("vip panel ctor data: " + data)
    self.init(data)
}
Panel.prototype.init = function (data) {
    var self = this
    BasePanel.prototype.init.call(self)
    let title = self.getChildByName("title")
    title.setPositionX(title.getPositionX() + 33)
    title.setScale(0.9)

    let close = UIGroupButton.create(self.getChildByName("btn_close"))
    PushBounceAnim.create(close)
    close.on(UIButtonEvent.Click, function () {
        self.onClose()
    })

    let question = UIGroupButton.create(self.getChildByName("btn_question"))
    PushBounceAnim.create(question)
    question.on(UIButtonEvent.Click, self.openInfoPanel)

    let rechargeBtn = UIGroupButton.create(self.getChildByName("btn_recharge"))
    PushBounceAnim.create(rechargeBtn)
    rechargeBtn.on(UIButtonEvent.Click, function () {
        DCAssist.userTrack("TencentVIP", "click_charge_btn")
        self.openMarket()
    })

    self.getBtn = UIGLabelButton.create(self.getChildByName("btn_get_package"))
    PushBounceAnim.create(self.getBtn)
    self.getBtn.on(UIButtonEvent.Click, function () {
        self.onGetBtnClick()
    })

    self.updateView(data)
}
Panel.prototype.updateView = function (data) {
    var self = this
    self.data = data

    self.giftId = data.currentGiftId

    // 设置vip等级图标
    let vipIconView = self.getChildByName("vip_level_icon")
    let vipLevel = data.vipLevel ? data.vipLevel : 0
    let vipIcon = cc.spriteFrameCache.getSpriteFrame("vip_privileges/vip" + data.vipLevel + ".png")
    vipIconView.setSpriteFrame(vipIcon)

    // 显示vip可领取的礼包
    let isNotVip = self.getChildByName("is_not_vip_text")
    if (data.vipLevel == 0) {
        isNotVip.setVisible(true)
        self.getBtn.setString("升级为VIP")
    } else {
        isNotVip.setVisible(false)

        let items = data.currentLevel
        self.rewardItems = table()
        self.rewards = items
        if (items[1]) {
            let icon = self.createRewardItem(items[1], 130, self.getBtn.getPositionY() - 10)
            self.addChild(icon)
            self.rewardItems[1] = icon
        }
        if (items[2]) {
            let icon = self.createRewardItem(items[2], 270, self.getBtn.getPositionY() - 10)
            self.addChild(icon)
            self.rewardItems[2] = icon
        }
        self.getBtn.getChildByName("label").setScale(1.3)
        self.getBtn.setString("领取")

        self.getBtn.setEnabled(!data.hasFetch)
    }


    // 显示下一级可领取的礼包
    let bgNextLevel = self.getChildByName("bg_next_level")
    let nextLevelTitle = self.getChildByName("next_level_package_title")
    if (data.nextLevel) {
        let items = data.nextLevel
        if (items[1]) {
            self.addChild(self.createRewardItem(items[1], 130, bgNextLevel.getPositionY() - 20))
        }
        if (items[2]) {
            self.addChild(self.createRewardItem(items[2], 270, bgNextLevel.getPositionY() - 20))
        }
    } else {
        bgNextLevel.setVisible(false)
        nextLevelTitle.setVisible(false)
    }
}
var i = 0
Panel.prototype.createRewardItem = function (item, posX, posY) {
    let self = this
    let icon = UIItemBuilder.createProp(item.itemId, item.num, 0, true)[0]
    icon.setScale(1.5)

    let lightCsb = "cocos/vip_privileges_racoon_light.csb"
    let animation = cc.CSLoader.createTimeline(lightCsb)

    let lightNode = cc.CSLoader.createNode(lightCsb)
    lightNode.runAction(animation)
    lightNode.setScale(0.5)
    lightNode.setPosition(posX, posY)
    animation.gotoFrameAndPlay(0, true)
    animation.setCurrentFrame(i * 10 - 2)
    i++
    lightNode.addChild(icon)
    return lightNode
}
Panel.prototype.playItemAnimation = function (onAnimFinish) {
    var self = this
    //move icon to world
    var scene = cc.Director.getInstance().getRunningScene()
    var layer = cc.Layer.create()
    scene.addChild(layer, 1100)
    var flyItemConfig = table()
    var $limit62 = $len(self.rewardItems)
    for (var i = 1; i <= $limit62; i += 1) {
        self.rewardItems[i].setVisible(false)
        var config = table()
        let index = i
        config.itemId = self.rewards[index].itemId
        config.num = self.rewards[index].num
        config.pos = self.convertToWorldSpace(cc.p(self.rewardItems[i].getPosition()))
        table.insert(flyItemConfig, config)
    }
    HomeSceneAnimation.playGetPropAnimation(flyItemConfig, onAnimFinish, 0.15)

}
Panel.prototype.cleanup = function () {
    unloadResList(resList)
    NewUserRewardPanel.prototype.cleanup.call(this)
}
Panel.prototype.openInfoPanel = function () {
    let self = this
    if (self.infoPanelBusy) {
        return
    }

    self.infoPanelBusy = true

    function onFail() {
        Toast.make("网络出了点问题啦~", 2, function () {
            self.infoPanelBusy = false
        })
    }

    function onCancel() {
        self.infoPanelBusy = false
    }

    require("clover/panel/VipPrivilegesInfoPanel").asyncCreate(function () {
        self.infoPanelBusy = false
    }, onFail, onCancel)
}
Panel.prototype.onGetBtnClick = function () {
    let self = this
    if (self.data.vipLevel) {
        if (self.isBusy) {
            return
        }

        DCAssist.userTrack("TencentVIP", "click_get_VIPbag_btn_" + self.data.vipLevel)
        self.isBusy = true
        GameProxy.getInstance().getWanbaGiftRewards(self.giftId, function () {
            var rewardCount = $len(self.rewards)
            for (var i = 1; i <= rewardCount; i += 1) {
                var v = self.rewards[i]
                UserProp.getInstance().rewardProp(v.itemId, v.num, null, null, ModuleName.WANBA_VIP_PRIVILEGES)
            }

            self.playItemAnimation(function () {
                self.isBusy = false
                self.data.hasFetch = true
                self.updateView(self.data)
            })
        }, function () {
            Toast.make("网络出了点问题啦~", 2, function () {
                self.isBusy = false
            })
        }, function () {
            self.isBusy = false
        })
    } else {
        DCAssist.userTrack("TencentVIP", "click_VIP_levelup_btn")
        self.openMarket()
    }
}
Panel.prototype.openMarket = function () {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    function onFail() {
        Toast.make(getText("error.tip.timeout"))
        self.isBusy = false
    }
    function onCancel() {
        self.isBusy = false
    }

    MarketPanel.show(tabId, onCancel, onFail)
}

module.exports = Panel